import { motion } from "framer-motion";
import { ArrowRight, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CTABanner({ onOpenLead }) {
  return (
    <section className="py-20 relative">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-3xl overflow-hidden p-10 md:p-16 bg-[#CCFF00]"
        >
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-black/10 blur-3xl" />
          <div className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full bg-white/20 blur-3xl" />

          <div className="relative grid md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-8">
              <div className="flex items-center gap-2 text-black/70 font-mono-jb text-xs uppercase tracking-widest">
                <Zap className="w-4 h-4" /> Ready when you are
              </div>
              <h3 className="font-display text-4xl sm:text-5xl md:text-6xl font-black text-black tracking-tighter mt-4 leading-[1.0]">
                Get a free quote in <br />
                under 24 hours.
              </h3>
              <p className="mt-4 text-black/80 text-lg max-w-xl">
                Tell us about your business — we'll send pricing, timeline, and
                a custom plan tailored to your goals.
              </p>
            </div>
            <div className="md:col-span-4 flex md:justify-end">
              <Button
                data-testid="cta-banner-button"
                onClick={onOpenLead}
                className="bg-black text-[#CCFF00] hover:bg-zinc-900 rounded-none px-8 py-6 h-auto text-base font-bold"
              >
                Claim My Quote
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
